import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsent } from '../../context/ConsentContext';
import { setOpenAIMarketingConsent, trackOpenAIPageView } from '../../utils/openaiPixel';

/**
 * Loads OpenAI Measurement Pixel only when marketing consent is granted
 * (prod + REACT_APP_OPENAI_PIXEL_ID). Tracks page_viewed on SPA route changes.
 */
const OpenAIPixel: React.FC = () => {
  const { marketing } = useConsent();
  const location = useLocation();
  const isFirstPageView = useRef(true);

  useEffect(() => {
    setOpenAIMarketingConsent(marketing);
  }, [marketing]);

  useEffect(() => {
    if (!marketing) return;

    if (isFirstPageView.current) {
      isFirstPageView.current = false;
      return;
    }

    trackOpenAIPageView();
  }, [location.pathname, location.search, marketing]);

  return null;
};

export default OpenAIPixel;
